import React,{useEffect, useCallback,useRef,useState} from 'react';
import { BrowserQRCodeReader } from '@zxing/library';
import {RSelect} from "@putil-view/input.r-select";
import PropTypes from 'prop-types';
export const QrScanner = ({handleScan,style,children}) => {
  const scannedData = useRef({time:new Date(), decodedText: null});
  const [source, setSource] = useState({});
  const codeReaderRef = useRef(new BrowserQRCodeReader());
  const videoRef = useRef(null);
  const handleResult = useCallback((qr) =>{
    if(qr && qr.text && (qr.text !== scannedData.current.text || (new Date().getTime() - scannedData.current.time.getTime() > 5000))){
      scannedData.current = {time:new Date(), text: qr.text};
      if(handleScan && !videoRef.current.paused)
        handleScan(qr.text);
    }
  },[handleScan]);

  const handleSelect = useCallback((event) =>{
    var video = videoRef.current;
    var codeReader = codeReaderRef.current;
    codeReader.reset();
    codeReader.timeBetweenScansMillis = 50
    codeReader.decodeFromInputVideoDeviceContinuously(source[event.target.value], video,handleResult);
  },[handleResult,source]);

  useEffect(()=>{

    var video = videoRef.current;
    if(video.currentTime <= 0 || video.paused === true || video.ended === true){
      var codeReader = codeReaderRef.current;
      var sourceFound = {};
      codeReader.getVideoInputDevices().then((videoInputDevices) => {
              sourceFound['Default'] = null;
              videoInputDevices.forEach((element) => {
                  sourceFound[element.label] = element.deviceId;
              })

          codeReader.timeBetweenScansMillis = 50
          codeReader.decodeFromInputVideoDeviceContinuously(null, video,handleResult);
          setSource(sourceFound);
      })
      .catch((err) => {
          console.error(err)
      })

    }
    return (()=>{
        codeReader.reset();

    })
  },[handleResult])

  return (
   <>
     {source && Object.keys(source).length !== 0 &&
       <div className="d-flex justify-content-center">
         <RSelect name="camera" id="camera_source_select" label={<>Camera</>} options={Object.getOwnPropertyNames(source)} value={null} handleChange={handleSelect}/>
       </div>
     }
    <div className="d-flex justify-content-center">



      <video  style={style} ref={videoRef}/>

      {children}
    </div>

    </>
  )
}
QrScanner.propTypes = {
  handleScan: PropTypes.func,
  stopWhenDetach:PropTypes.bool,
  handleCapture: PropTypes.func,
  style:PropTypes.object,
  children:PropTypes.object,
};
